<template>

  <div>
    <div class="alert alert-secondary mb-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
        <label class="form-check-label" for="defaultCheck1">
          Habilitar AutoEngage
        </label>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label">* {{ $t('Title') }}</label>
      <input v-autofocus class="form-control" type="text">
    </div>

    <div class="form-group">
      <label class="control-label">* {{ $t('Contrato') }}</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="contract1"
          name="contract">
        <label
          class="form-check-label"
          for="contract1">
          {{ $t('PJ') }}
          </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="contract2"
          name="contract">
        <label
          class="form-check-label"
          for="contract2">
          {{ $t('Estágio') }}
          </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          id="contract3"
          name="contract">
        <label
          class="form-check-label"
          for="contract3">
          {{ $t('CLT') }}
          </label>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label">* {{ $t('Faixa salarial') }}</label>
      <input v-autofocus class="form-control" type="text">
    </div>

    
    <div
      v-for="(item, i) in schema"
      :key="i"
      class="mb-4">
      <div class="mb-2">
        <b>{{ item.name }}</b>
      </div>
      <div
        v-if="item.type === 'options'"
        class="options">
        <label
          v-for="(option, o) in item.options"
          :key="o"
          class="btn btn-block"
          :class="{ 'btn-outline-primary': item.values[option], 'btn-light': !item.values[option] }">
          <input
            v-model="item.values[option]"
            type="checkbox"
            :name="'item' + i">
          {{ option }}
        </label>
      </div>
      <div
        v-if="item.type === 'options-binary'">
        <div
          v-for="(option, o) in item.options"
          :key="o"  
          class="btn-option-binary mb-1">
          <button
            :class="{ 'btn-outline-primary': item.values[o] === option[0], 'btn-light': item.values[o] !== option[0] }"
            @click="$set(item.values, o, item.values[o] === option[0] ? null : option[0])"  
            type="button"
            class="btn">{{ option[0] }}</button>
          <button
            :class="{ 'btn-outline-primary': item.values[o] === option[1], 'btn-light': item.values[o] !== option[1] }"
            @click="$set(item.values, o, item.values[o] === option[1] ? null : option[1])"  
            type="button"
            class="btn">{{ option[1] }}</button>
        </div>
      </div>
      <div
        v-if="item.type === 'options-experience'">
        <label
          v-for="(option, o) in item.options"
          :key="o"
          class="btn btn-block btn-options"
          :class="{ 'btn-outline-primary': item.values[option], 'btn-light': !item.values[option] }">
          <span>{{ option }}</span>
          <select
            v-model="item.values[option]"
            class="custom-select">
            <option :value="null">...</option>
            <option :value="1">Desejavel - Estágio</option>
            <option :value="2">Desejavel - Júnior (1 a 2 anos)</option>
            <option :value="3">Desejavel - Pleno (3 a 4 anos)</option>
            <option :value="4">Desejavel - Senior (5 a 8 anos)</option>
            <option :value="5">Desejavel - Especialista</option>
            <option :value="6">Obrigatório - Estágio</option>
            <option :value="7">Obrigatório - Júnior (1 a 2 anos)</option>
            <option :value="8">Obrigatório - Pleno (3 a 4 anos)</option>
            <option :value="9">Obrigatório - Senior (5 a 8 anos)</option>
            <option :value="10">Obrigatório - Especialista</option>
          </select>
        </label>
      </div>
    </div>

    
    <div class="form-group">
      <label class="control-label">* {{ $t('Descritivo da vaga') }}</label>
      <textarea-editable
        editor-model="html"
        :enable-link="true"
        :enable-img="true"></textarea-editable>
    </div>
    <div class="form-group">
      <label class="control-label">* {{ $t('Beneficios') }}</label>
      <textarea-editable
        editor-model="html"
        :enable-link="true"
        :enable-img="true"></textarea-editable>
    </div>
    <div class="form-group">
      <label class="control-label">* {{ $t('Perguntas para candidatura') }}</label>
      <input v-autofocus class="form-control" type="text">
    </div>

    <div>
      <button
        type="button"
        class="btn btn-primary"
        @click="save">Salvar</button>
    </div>
  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import RhevolutJobForm from './RhevolutJobForm'
import RhevolutJobItem from './RhevolutJobItem'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'RhevolutJob',
  components: {
    ThSort,
    RhevolutJobForm,
    RhevolutJobItem,
    Paginaty
  },
  props: [
  ],
  data () {
    return {
      tab: 'matching',
      candidateId: null,
      schema: [{
        type: 'options',
        name: 'Quais os 3 valores/cultura mais importantes que o talento deve possuir?',
        options: [
          'Decisões baseadas em dados',
          'Diversidade e Inclusão',
          'Flexibilidade e bem estar',
          'Liderança ativa',
          'Orientação para resultados',
          'Propósito com o produto/serviço',
          'Reconhecimento e bonificação',
          'Trabalhar com pessoas extraordinárias',
          'Trabalho desafiador',
          'Transparência e respeito'
        ],
        values: {
          'Decisões baseadas em dados': true,
          'Diversidade e Inclusão': true,
          'Flexibilidade e bem estar': true
        }
      }, {
        type: 'options',
        name: 'Para qual área é a vaga?',
        options: [
          'Backend',
          'Consultoria',
          'CS/CX',
          'Dados',
          'Design',
          'Devops',
          'Engenharia',
          'ESG',
          'Finanças',
          'Frontend',
          'Jurídico',
          'Marketing',
          'Mobile',
          'Produto',
          'QA',
          'RH',
          'Sales',
          'Segurança da Informação',
          'Supply Chain',
          'Varejo'
        ],
        values: {
          'Backend': true,
          'Frontend': true
        }
      }, {
        type: 'options-experience',
        name: 'Clique uma vez se eles são opcionais (aparecerá um check). Clique 2 vezes se for obrigatório (aparecerá um cadeado)',
        options: [
          '.NET',
          'ABAP',
          'APEX',
          'C',
          'C#',
          'c++',
          'Clojure',
          'Elixir',
          'Erlang',
          'GO',
          'Haskel',
          'Java',
          'kotlin',
          'Node.js',
          'PHP',
          'Python',
          'Ruby',
          'Rust',
          'Scala',
          'Swift',
          'TypeScript',
          'Júnior'
        ],
        values: {
          'Python': 8,
          'TypeScript': 9,
          'Node.js': 3
        }
      }, {
        type: 'options',
        name: 'Qual a forma do trabalho?',
        options: [
          'Híbrido',
          'Presencial',
          'Remoto'
        ],
        values: {
          'Híbrido': true,
          'Presencial': true,
          'Remoto': true
        }
      }, {
        type: 'options',
        name: 'Qual o local do trabalho?',
        options: [
          'Americana',
          'Araçatuba',
          'Araraquara',
          'Atibaia',
          'Barueri',
          'Bauru',
          'Bragança Paulista',
          'Campinas',
          'Carapicuíba',
          'Cotia',
          'Diadema',
          'Embu das Artes',
          'Ferraz de Vasconcelos',
          'Franca',
          'Francisco Morato',
          'Guarujá',
          'Guarulhos',
          'Hortolândia'
        ],
        values: {
          'Americana': true,
          'Araçatuba': true,
          'Araraquara': true
        }
      }, {
        type: 'options',
        name: 'Quais idiomas o talento precisa saber?',
        options: [
          'Alemão',
          'Espanhol',
          'Francês',
          'Inglês'
        ],
        values: {
          'Inglês': true,
          'Francês': true
        }
      }, {
        type: 'options',
        name: 'Quais são as 2 principais vantagens que esta posição oferece?',
        options: [
          'Bônus por desempenho/entregas',
          'Carga horária semanal reduzida',
          'Impacto Social',
          'Investimento em sua qualificação',
          'Oportunidade de Crescimento',
          'Oportunidade de mudança de país',
          'Oportunidades em time global',
          'Propósito e identificação com o negócio',
          'Qualidade de vida',
          'Remuneração acima do mercado'
        ],
        values: {
          'Carga horária semanal reduzida': true,
          'Impacto Social': true,
          'Investimento em sua qualificação': true
        }
      }, {
        type: 'options',
        name: 'Quais características podem fazer parte desta vaga? (quantas quiser)',
        options: [
          'Baixo índice de diversidade no time',
          'Cobrança enérgica por metas e entregas',
          'Liderança pouco próxima',
          'Nenhuma delas',
          'Pouca autonomia',
          'Pouca flexibilidade com horário',
          'Precisar viajar com frequência',
          'Trabalho frequente fora do horário'
        ],
        values: {
          'Baixo índice de diversidade no time': true,
          'Cobrança enérgica por metas e entregas': true,
          'Pouca autonomia': true
        }
      }, {
        type: 'options',
        name: 'Selecione os 5 valores mais importantes para a vaga',
        options: [
          'Confiança',
          'Diversidade',
          'Ética',
          'Gentileza',
          'Independência',
          'Justiça',
          'Paciência',
          'Paixão',
          'Relacionamento',
          'Segurança',
          'Simplicidade',
          'Transparência'
        ],
        values: {
          'Justiça': true,
          'Paciência': true,
          'Paixão': true
        }
      }, {
        type: 'options-binary',
        name: 'Marque as opções do perfil ideal para a vaga',
        options: [
          ['Bem humorado', 'Reservado'],
          ['Colaboração', 'Competição'],
          ['Analítico', 'Criativo'],
          ['Diplomático', 'Direto'],
          ['Flexibilidade', 'Previsibilidade'],
          ['Formalidade', 'Informalidade'],
          ['Extrovertido', 'Introspectivo'],
          ['Liderança', 'Processos definidos'],
          ['Prestígio', 'Propósito'],
          ['Detalhista', 'Rapidez'],
          ['Qualidade de vida', 'Trabalho é prioridade'],
          ['Execução', 'Visão e estratégia']
        ],
        values: {
          '1': 'Colaboração',
          '2': 'Criativo',
          '4': 'Flexibilidade',
          '7': 'Liderança',
          '9': 'Rapidez'
        }
      }]
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    save () {
      this.$emit('save')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.options {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
  .options label.btn {
    flex: calc(50% - 0.4em);
    text-align: left;
    margin: 0.2em;
  }
.btn-options {
  padding: 0.5em;
  display: flex;
}
  .btn-options > span {
    display: block;
    padding: 0.4em;
    flex: 1;
    text-align: left;
  }
  .btn-options > select {
    display: block;
    flex: 1;
  }
.btn-option-binary {
  display: flex;
}
  .btn-option-binary > * {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/RhevolutJob/RhevolutJobConfig.vue